import * as React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import SvgIcon from "@mui/material/SvgIcon";

class Button extends React.Component<
    React.ButtonHTMLAttributes<HTMLButtonElement> & {
        title?: string;
        onClick?: () => void;
        onDisabledClick?: () => void;
        submit?: boolean;
        right?: boolean;
        outlined?: boolean;
        disabled?: boolean;
        loading?: boolean;
        innerRef?: React.RefObject<HTMLButtonElement>;
        Icon?: typeof SvgIcon;
        displayNone?: boolean;
        className?: string;
    }
> {
    public render(): React.ReactElement {
        const { title, onClick, onDisabledClick, innerRef, submit, right, outlined, style, disabled, Icon, loading, className, ...other } =
            this.props;
        return (
            <button
                className={`${outlined ? "button_flat" : "button_primary"} ${className}`}
                ref={innerRef}
                type={submit ? "submit" : "button"}
                onClick={disabled ? onDisabledClick : onClick}
                style={{
                    marginLeft: right ? "auto" : "",
                    minWidth: title ? undefined : "30px",
                    ...style
                }}
                {...other}
            >
                {loading ? (
                    <MuiCircularProgress className="progress" size={18} />
                ) : (
                    <>
                        {Icon && <Icon />}
                        {title}
                    </>
                )}
            </button>
        );
    }
}

export { Button };
